<template>
  <!--股票对比选择框-->
  <div>
    <div class="bannerImg"></div>
    <div class="lable">可比较2-5家A股上市公司，请输入股票名称或股票代码</div>

    <el-select class="input" v-model="curSymbols" multiple filterable :filter-method="searchStock" placeholder="搜索股票">
      <el-option v-for="item in stockOption" :key="item.symbol" :label="item.name" :value="item.symbol"
        :disabled="curSymbols.length > 4"></el-option>
    </el-select>
    <div class="lable">推荐组合</div>
    <a href="javascript:void(0)">
      <div class="tag">
        <el-tag @click="quikGenCompare('600519,000858')">&nbsp;贵州茅台&nbsp;&nbsp;&nbsp;五粮液&nbsp;</el-tag>
      </div>
    </a>&nbsp;&nbsp;
    <a href="javascript:void(0)">
      <div class="tag">
        <el-tag
          @click="quikGenCompare('601238,600104,002594,000625,601633')">&nbsp;广汽集团&nbsp;&nbsp;&nbsp;上汽集团&nbsp;&nbsp;&nbsp;比亚迪&nbsp;&nbsp;&nbsp;长安汽车&nbsp;&nbsp;&nbsp;长城汽车&nbsp;</el-tag>
      </div>
    </a>
    <div style="clear: both;height:10px"></div>
    <a href="javascript:void(0)">
      <div class="tag">
        <el-tag
          @click="quikGenCompare('000651,000333,002959')">&nbsp;格力电器&nbsp;&nbsp;&nbsp;美的集团&nbsp;&nbsp;&nbsp;小熊电器&nbsp;</el-tag>
      </div>
    </a>&nbsp;&nbsp;
    <a href="javascript:void(0)">
      <div class="tag">
        <el-tag
          @click="quikGenCompare('000423,600436,600085,000538')">&nbsp;东阿阿胶&nbsp;&nbsp;&nbsp;片仔癀&nbsp;&nbsp;&nbsp;同仁堂&nbsp;&nbsp;&nbsp;云南白药&nbsp;</el-tag>
      </div>
    </a>
    <div slot="footer" class="dialog-footer">
      <el-row style="clear:both;min-height:30px;text-align:left">
      </el-row>
      <el-button type="primary" @click="genCompare('')">开始写作</el-button>
    </div>
  </div>
</template>

<script>

// import Loading from '../components/js/Loading'
export default {
  name: 'index',
  data: function () {
    return {

      curSymbol: '',
      curSymbols: '',
      stockList: [],
      stockOption: []

    }
  },

  methods: {

    searchStock (key) {
      this.stockOption = []
      console.log(key)
      key = key.toUpperCase()

      for (let stock of this.stockList) {
        if (this.stockOption.length > 4) {
          break
        }

        if (stock.symbol.indexOf(key) > -1 ||
          stock.name.indexOf(key) > -1 ||
          stock.pinyin.indexOf(key) > -1) {
          this.stockOption.push(stock)
        }
      }
    },

    quikGenCompare (symbols) {
      this.genCompare(symbols)
    },
    genCompare (symbols) {
      if (!symbols) {
        symbols = this.curSymbols.join(',')
      }
      this.axios.getWithLoading(`/webApi/v3/robot/stock/portfolioReport?stockCodes=${symbols}`).then(resp => {
        this.$router.push({ path: '/newsEdit', query: { articleId: resp.data.autoNewsId, 'from': 'finance' } })
      }).catch(() => {
        this.stockOption = []
      })
    }

  },
  components: {

  },
  watch: {

  },
  mounted () {
    let _this = this
    this.axios.get('/webApi/v3/finace/all_stock_list_basic_data').then(resp => {
      _this.stockList = resp.data
      _this.stockOption = _this.stockList.slice(0, 5)
    })
  }
}
</script>
<style lang="less" scoped>
.bannerImg {
  background-image: url('../../assets/imgs/compareBanner.png');
}
</style>



// WEBPACK FOOTER //
// src/components/write/compare.vue